import { Skeleton } from '@mui/material';

import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';
import {
  APPLICATIONS_TABLE_COLUMNS_AMOUNT,
  APPLICATIONS_TABLE_COLUMNS_AMOUNT_INACTIVE,
} from 'components/applications/applications.constants';

import styles from './ApplicationsTableSkeletonRow.module.scss';

interface ApplicationsTableSkeletonRowProps {
  isInactiveApplicationsFilterEnabled?: boolean;
}

const ApplicationsTableSkeletonRow = ({
  isInactiveApplicationsFilterEnabled = false,
}: ApplicationsTableSkeletonRowProps) => {
  const columnsCount = isInactiveApplicationsFilterEnabled
    ? APPLICATIONS_TABLE_COLUMNS_AMOUNT_INACTIVE
    : APPLICATIONS_TABLE_COLUMNS_AMOUNT;
  const rowClass = isInactiveApplicationsFilterEnabled ? styles.tableRowContainerInactive : styles.tableRowContainer;

  return (
    <TableRow className={rowClass} isHoverDisabled>
      {Array.from({ length: columnsCount }).map((_, skeletonColumn) => (
        <TableBodyCell key={skeletonColumn}>
          <Skeleton variant="rounded" height={16} animation="wave" />
        </TableBodyCell>
      ))}
    </TableRow>
  );
};

export default ApplicationsTableSkeletonRow;
